import type { Locale } from '@/constants/i18n'

export type Currency = 'EUR' | 'TND'

export const isCurrency = (value: unknown): value is Currency => value === 'EUR' || value === 'TND'

const GROUP: Record<Locale, string> = { en: ',', de: '.', fr: ' ', ar: ',' }
const DECIMAL: Record<Locale, string> = { en: '.', de: ',', fr: ',', ar: '.' }

export const roundMoney = (value: number): number => Math.round(value * 100) / 100

export const formatNumber = (value: number, locale: Locale = 'de'): string => {
    const rounded = roundMoney(value)
    const decimals = Number.isInteger(rounded) ? 0 : 2
    const [integer, fraction] = Math.abs(rounded).toFixed(decimals).split('.')
    const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, GROUP[locale])
    const sign = rounded < 0 ? '-' : ''

    return fraction ? `${sign}${grouped}${DECIMAL[locale]}${fraction}` : `${sign}${grouped}`
}

export const formatMoney = (value: number, currency: Currency, locale: Locale = 'de'): string => {
    const number = formatNumber(value, locale)

    if (currency === 'EUR') return locale === 'en' ? `€${number}` : `${number} €`

    return locale === 'ar' ? `${number} د.ت` : `${number} TND`
}
